<template>
  <div id="addBadge" class="tab-pane" role="tabpanel">
    <validation-observer ref="registerForm" #default="{ invalid }">
      <b-form>
        <b-row>
          <b-col lg="3">
            <b-form-group id="input-group-29" :label="$t('edu_programs.edu_programs')" label-for="input-29">
              <v-select v-model="eduProgramId" :options="eduPrograms" class="w-100" label="name"
                :reduce="(item) => item.id" @input="changeEduPrograms(eduProgramId)" />
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-form-group id="input-group-29" :label="$t('students.students')" label-for="input-29">
              <v-select v-model="newItem.user_id" :options="students" class="w-100" label="email"
                :reduce="(item) => item.id" @input="changeStudent(studentId)" />
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-form-group id="input-group-29" label=" منهج الرسوب" label-for="input-29">
              <v-select v-model="newItem.edu_course_id" :options="courses" class="w-100" label="name"
                :reduce="(item) => item.id" />
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-form-group id="input-group-29" label="المنهج الملغي" label-for="input-29">
              <v-select v-model="newItem.new_edu_course_id" :options="courses" class="w-100" label="name"
                :reduce="(item) => item.id" />
            </b-form-group>
          </b-col>
         
        </b-row>
        <hr />
        <b-row>
          <b-col lg="6">
            <b-form-group id="input-group-29" :label="$t('edu_programs.edu_programs')" label-for="input-29">
              <v-select v-model="eduProgramNewId" :options="eduPrograms" class="w-100" label="name"
                :reduce="(item) => item.id" @input="changeEduProgramsNew(eduProgramNewId)" />
            </b-form-group>
          </b-col>

          <b-col lg="6">
            <b-form-group id="input-group-29" :label="$t('rooms.rooms')" label-for="input-29">
              <v-select v-model="newItem.room_id" :options="rooms" class="w-100" label="name"
                :reduce="(item) => item.id" />
            </b-form-group>
          </b-col>
         
        </b-row>
       
       
        <hr />
        <b-row>
          <b-col lg="6">
            <b-btn variant="primary" block @click="submit()" :disabled="invalid">
              <i class="fa fa-plus" /> {{ $t("site.save") }}</b-btn>
          </b-col>
          <b-col lg="6">
            <b-btn variant="success" block @click="goToTable()">
              <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-btn>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import controller from "../../../../Controllers/FailedUsersRoomsController";
import EduProgramsController from "@/Controllers/EduProgramsController";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import vSelect from "vue-select";
import { forEach } from 'postcss-rtl/lib/affected-props';

export default {
  name: "FailedUsersRooms",

  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    vSelect,
  },
  data() {
    return {
      eduProgramId: 0,
      eduProgramNewId: 0,
      eduProgram: {},
      eduPrograms: [],
      students: [],
      student: {},
      courses: [],
      courseId: {},
      rooms: [],
      roomId: {},
      eduProgramNewCourseId:0,
      eduProgramNewCourse:[]

    }
  },
  async created() {
    //getCourse
    this.eduPrograms = await new EduProgramsController().GetAll({
      with: ["students", "courses", "rooms"],
    });
  },
  methods: {
    async submit() {
      delete this.newItem.edu_course;
      delete this.newItem.room;
      delete this.newItem.user;
     
      let ret = await new controller().From(this.newItem,'FormData');
      if (ret) {
        this.goToTable();
      }
    },
    changeEduPrograms(eduProgramId) {
      this.eduProgram = {};
      this.eduProgram = this.eduPrograms.find((a) => (a.id == eduProgramId));
      this.students = this.eduProgram.students
      this.courses = this.eduProgram.courses

    },
    changeEduProgramsCourses(eduProgramNewCourseId) {
      
     const eduPrograms= this.eduPrograms.find((a) => (a.id == eduProgramNewCourseId));
       this.eduProgramNewCourse = eduPrograms.courses

    },
    changeEduProgramsNew(eduProgramNewId) {
      const eduProgram = this.eduPrograms.find((a) => (a.id == eduProgramNewId));
      this.rooms =eduProgram.rooms


    },
    changeStudent(studentId) {
      this.student = {};
      this.student = this.students.find((a) => (a.id == studentId));


    },
    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
  },
  watch: {
    newItem(to, from) {
     
      for (let index = 0; index < this.eduPrograms.length; index++) {
        const eduProgram = this.eduPrograms[index];
       const student = eduProgram.students.find((a) => (a.id == to.user_id));
        if (student) {
          this.eduProgramId=eduProgram.id  
          this.students = eduProgram.students
          this.courses = eduProgram.courses
          break;
        }
      }
     

      for (let index = 0; index < this.eduPrograms.length; index++) {
        const eduProgram = this.eduPrograms[index];
        const  room = eduProgram.rooms.find((a) => (a.id == to.room_id));
        if (room) {
          this.eduProgramNewId=eduProgram.id  
          this.rooms =eduProgram.rooms
          break;

        }
      }

      console.log(eduProgramOld, to.user_id);
    }
  }
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
  